import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { UserService } from 'src/app/core/common-services/user.services';
import { InvestingType } from 'src/app/core/data-models/kyc.data.models';
import { UserDataService } from 'src/app/core/data-services/identity/user.data.service';
import { MenuDataService } from 'src/app/core/data-services/MenuData/menu-data.service';
import { NotificationDataService } from 'src/app/core/data-services/notification/notification-data.service';
import { LanguageService } from 'src/app/shared/services/language.service';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy{
  @ViewChild('logoutTemplateRef') logoutTemplateRef!: TemplateRef<any>;

  breakPoinSubscription!:Subscription;
  investTypes=InvestingType;
  menuItems: any[] = [];

  @Input() sidebarCollapsed: boolean = false;
  @Input() isRtl: boolean= false;
  @Input() isMobileView: boolean = false;
  @Output() collapseSidebar = new EventEmitter<void>();
  constructor(
    private userDataService : UserDataService,
    protected userService: UserService,
    private matDialog:MatDialog,
    public languageService:LanguageService,
    private responsive: BreakpointObserver,
    private notificationDataService:NotificationDataService,
    public notificationService:NotificationService,
      private menuService: MenuDataService,
      private router: Router,
  ){

  }
ngOnDestroy(): void {
  if (this.breakPoinSubscription) {
    this.breakPoinSubscription.unsubscribe();
  }
}

  ngOnInit(): void {
    // Use the language service instead of direct localStorage access
    this.isRtl = this.languageService.currentLanguage === 'ar';
    this.checkMobileView();
    this.loadMenu();
    window.addEventListener('resize', () => this.checkMobileView());
    
    // Listen to language changes and update RTL
    window.addEventListener('storage', (e) => {
      if (e.key === 'currentLang') {
        this.isRtl = e.newValue === 'ar';
      }
    });
  }
 checkMobileView() {
    this.isMobileView = window.innerWidth <= 991;
  }
loadMenu(): void {
  this.menuService.getUserMenu().subscribe({
    next: (res) => {
      if (res?.success) {
        this.menuItems = res.resource?.menuTree ?? [];
        console.log(this.menuItems);
      }
    },
    error: (err) => {
      this.notificationService.error('❌ Menu load error:'); 
    }
  });
}

  collapseSide() {
    this.sidebarCollapsed = !this.sidebarCollapsed;
      this.collapseSidebar.emit();
  }
  // ngOnInit(): void {
  //  this.breakPoinSubscription= this.responsive.observe([
  //   Breakpoints.Small,
  //   Breakpoints.Handset,
  //   Breakpoints.Tablet,
  //   Breakpoints.HandsetPortrait,
  //   Breakpoints.HandsetLandscape,
  //   Breakpoints.TabletPortrait,
  //   Breakpoints.TabletLandscape,
  //     ])
  //     .subscribe(result => {

  //       this.isMobileView = false;

  //       if (result.matches) {
  //         this.isMobileView = true;
  //       }
  //       console.log('isMobileView:'+this.isMobileView)

  // });
  // this.getPushNotificationsCount();
  // }
getPushNotificationsCount(){
  this.notificationDataService.GetUnreadNotificationsCount().subscribe({
    next:(res)=>{
      if(res&&res.data){
        this.notificationService.unreadPushNotificationsCount=res.data.unreadNotificationsCount;
      }
    }
  })
}
 logOut() {
  this.closeLogoutDialog();
  return this.userDataService.Logout().subscribe({
    next: () => {
      this.notificationService.success('Logged out successfully!');
      this.userService.logout();
    },
    error: (err) => {
      this.notificationService.error('Error occurred during logout:'); 
      this.userService.logout();
    }
  });
}
  closeLogoutDialog(){
    this.matDialog.closeAll();
  }
  openLogoutDialog(){
    this.closeLogoutDialog();
    this.matDialog.open(this.logoutTemplateRef, {
      height: 'auto',
      width:'600px',
      panelClass:'dialog-class',
    });
  }

  closeMenu() {
    this.isMobileView = false;
  }
  toggleExpand(item: any) {
  item.expanded = !item.expanded;
}

  isMenuItemActive(route: string): boolean {
    if (!route) {
      return false;
    }

    const currentUrl = this.normalizeMenuRoute(this.router.url);
    const itemRoute = this.normalizeMenuRoute(route);
    const matches =
      currentUrl === itemRoute || currentUrl.startsWith(`${itemRoute}/`);

    if (!matches) {
      return false;
    }

    for (const otherRoute of this.getAllMenuRoutes()) {
      const other = this.normalizeMenuRoute(otherRoute);
      if (
        other.length > itemRoute.length &&
        other.startsWith(`${itemRoute}/`) &&
        (currentUrl === other || currentUrl.startsWith(`${other}/`))
      ) {
        return false;
      }
    }

    return true;
  }

  private getAllMenuRoutes(): string[] {
    const routes: string[] = [];

    for (const item of this.menuItems) {
      if (item.route) {
        routes.push(item.route);
      }

      for (const child of item.children ?? []) {
        if (child.route) {
          routes.push(child.route);
        }
      }
    }

    return routes;
  }

  private normalizeMenuRoute(route: string): string {
    return route.split('?')[0].split('#').pop()!.replace(/^\/+/, '').toLowerCase();
  }
}
